import { SxProps, Theme } from '@mui/material';

export const addAddressButton: SxProps<Theme> = (theme) => ({
	background: '#FFF',
	color: 'primary.main',
	width: '100%',
	// height: '100%',
	border: '1px solid #e0e0e0',
	display: 'flex',
	flexDirection: 'column',
	borderRadius: '5px',
	padding: '20px',
	height: '155px',
	[theme.breakpoints.down('md')]: {
		maxWidth: '100%',
	},
	'&:hover': {
		background: '#774A91',
		color: '#FFF',
		border: '1px solid #774A91',
	},
});

export const addNotAddressButton: SxProps<Theme> = (theme) => ({
	background: '#FFF',
	color: 'primary.main',
	width: '25%',
	height: '100%',
	border: '1px solid #e0e0e0',
	display: 'flex',
	flexDirection: 'column',
	borderRadius: '5px',
	[theme.breakpoints.down('md')]: {
		maxWidth: '100%',
	},
	'&:hover': {
		background: 'primary.main',
		color: '#FFF',
		border: '1px solid #774A91',
	},
});

export const containerAddressook: SxProps<Theme> = (theme) => ({
	[theme.breakpoints.down('md')]: {
		// marginLeft: '16px',
	},
});

export const DataCompleteAddressook: SxProps<Theme> = (theme) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'left',
	width: '50%',

	[theme.breakpoints.down('md')]: {
		width: 'auto',
		display: 'flex',
		justifyContent: 'center',
		marginBottom: '18px',
	},
});

export const AddreessModalFrameSX = (isMobile: boolean, theme: any): SxProps<Theme> => ({
	position: 'absolute',
	top: isMobile ? undefined : '60%',
	[theme.breakpoints.down('sm')]: {
		height: '70%',
	},
	left: isMobile ? 0 : '50%',
	bottom: isMobile ? 0 : undefined,
	transform: isMobile ? undefined : 'translate(-50%, -50%)',
	width: isMobile ? '100%' : '50%',
	maxWidth: isMobile ? '100%' : '661px',
	bgcolor: 'background.paper',
	boxShadow: 2,
	borderRadius: '6px',
	borderBottomLeftRadius: isMobile ? 0 : '6px',
	borderBottomRightRadius: isMobile ? 0 : '6px',
	margin: '0px',
});
